import React from 'react';
import UserLayout from '../layout/UserLayout';

const Contact = () => {
  return (
    <UserLayout>
      <div>Contact</div>
    </UserLayout>
  );
};

export default Contact;
